import React, { useState } from 'react';
import { WP_Faq } from '../../model/models';
import { SanitizeHTML } from '../globals/SanitizeHTML';

interface FaqProps {
  faq: WP_Faq;
  page?: boolean;
}

export const Faq: React.FC<FaqProps> = ({ faq, page }) => {
  const faq_not_empty = faq !== undefined ? faq : false;

  const [isActive, setActive] = useState(-1);

  const openAnswer = (i) => {
    isActive === i ? setActive(-1) : setActive(i);
  };

  return faq_not_empty ? (
    <div
      className={` ${
        !page ? 'bg-white rounded-3xl py-10 px-5 -mt-7 md:-mt-0' : 'mt-7'
      }`}
    >
      {!page && <h2 className="font-bold text-lg text-center">FAQ</h2>}
      <div className="mt-4">
        <ul className="flex flex-col">
          {faq.map((person, i) => (
            <li
              key={i}
              className="mb-4"
              onClick={() => {
                openAnswer(i);
              }}
            >
              {!page ? (
                <h3
                  className={`flex justify-between items-center text-base text-left font-sans mb-5 text-black font-bold ${
                    isActive === i ? 'text-primary' : ''
                  } cursor-pointer`}
                >
                  <SanitizeHTML html={person.faq_ask} />
                  <svg
                    className={`${
                      isActive === i ? 'transform rotate-180' : 'ml-6'
                    }`}
                    width={`15`}
                    height="15"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity={`1`}
                      d="M9 1L5.18844 4.65834C5.16371 4.68211 5.13434 4.70097 5.102 4.71384C5.06967 4.72671 5.035 4.73333 5 4.73333C4.965 4.73333 4.93033 4.72671 4.898 4.71384C4.86566 4.70097 4.83629 4.68211 4.81156 4.65834L1 1"
                      stroke={`${isActive === i ? '#47D7AC' : '#000'}`}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={`2`}
                    />
                  </svg>
                </h3>
              ) : (
                <h2
                  className={`flex justify-between items-center text-lg text-left font-sans font-bold mb-5 text-black md:text-xl ${
                    isActive === i ? 'text-primary' : ''
                  } cursor-pointer`}
                >
                  <SanitizeHTML html={person.faq_ask} />
                  <svg
                    className={`${
                      isActive === i ? 'transform rotate-180' : 'ml-6'
                    }`}
                    width={`15`}
                    height="15"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity={`1`}
                      d="M9 1L5.18844 4.65834C5.16371 4.68211 5.13434 4.70097 5.102 4.71384C5.06967 4.72671 5.035 4.73333 5 4.73333C4.965 4.73333 4.93033 4.72671 4.898 4.71384C4.86566 4.70097 4.83629 4.68211 4.81156 4.65834L1 1"
                      stroke={`${isActive === i ? '#47D7AC' : '#000'}`}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={`2`}
                    />
                  </svg>
                </h2>
              )}

              <SanitizeHTML
                html={person.faq_answer}
                className={`faq-text text-left text-base text-black ion-text-wrap ${
                  isActive === i ? 'block' : 'hidden'
                } ${!page ? 'pl-4' : ''}`}
              />
              <hr className="w-full border-black opacity-10"></hr>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Faq;
